import {GenderGap_SAVE_Preventive_Question, GenderGap_SAVE_Questions} from "./request-manager";


export const setOpenAnswer = ( ratingID, questionID, openAnswers ) => {
    return GenderGap_SAVE_Questions( ratingID, questionID, openAnswers );
}


export const setPreventiveQuestion = ( ratingID, questionID, choicheID ) => GenderGap_SAVE_Preventive_Question( ratingID, questionID, choicheID );
